import React from "react";
import { useProductEducation } from "../../productEducation";
import { CrewPilotModuleShell } from "../CrewPilotModuleShell";
import { PAGE_LAYOUT } from "../../layout/pageLayout";
import { useIsDesktopViewport } from "../../hooks/useIsDesktopViewport";
import "./adminDesktop.css";
import { ScreenBackButton } from "../navigation/ScreenBackButton";
import { ProductEducationSettingsScreen } from "../../productEducation/settings/ProductEducationSettingsScreen";

export function AdminProductEducationScreen({ onBack }) {
  const {
    settings,
    updateSettings,
    openWhatsNew,
    replayLatestRelease,
    replayAshleyBriefing,
  } = useProductEducation();

  const isDesktop = useIsDesktopViewport();
  const education = (
    <ProductEducationSettingsScreen
      settings={settings}
      onUpdateSettings={updateSettings}
      onReplayLatestRelease={replayLatestRelease}
      onReplayAshleyBriefing={replayAshleyBriefing}
      onOpenWhatsNew={openWhatsNew}
      onReplayFirstTimeOnboarding={() => {}}
    />
  );

  if (isDesktop) {
    return (
      <CrewPilotModuleShell
        title="Help & Learning"
        subtitle="Release education and replay controls"
        sectionLabel="System"
        onBack={onBack}
        layout={PAGE_LAYOUT.FORM}
      >
        <div className="adm-edu adm-narrow">{education}</div>
      </CrewPilotModuleShell>
    );
  }

  return (
    <div>
      <ScreenBackButton onBack={onBack} />
      <ProductEducationSettingsScreen
        settings={settings}
        onUpdateSettings={updateSettings}
        onReplayLatestRelease={replayLatestRelease}
        onReplayAshleyBriefing={replayAshleyBriefing}
        onOpenWhatsNew={openWhatsNew}
        onReplayFirstTimeOnboarding={() => {}}
      />
    </div>
  );
}
